import React from 'react';
import { ColumnButton } from 'lib/components/ColumnButton';

type StripeDirectDepositOnboardingButtonProps = {
  isLoading: boolean;
  onClick: () => void;
  fromRegistration?: boolean;
};

export function StripeDirectDepositOnboardingButton({
  isLoading,
  onClick,
  fromRegistration
}: StripeDirectDepositOnboardingButtonProps) {
  if (fromRegistration) {
    return null;
  }

  return (
    <div>
      <div>
        <div className="flex items-center justify-center">
          <ColumnButton
            type="button"
            primary
            id="direct-deposit"
            buttonText="Get paid via direct deposit"
            loading={isLoading}
            disabled={isLoading}
            onClick={onClick}
          />
        </div>
      </div>
    </div>
  );
}
